// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.t2k_C{display:flex;gap:10px;align-items:center;margin:3px}.Smtkc{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `t2k_C`,
	"checkbox": `Smtkc`
};
export default ___CSS_LOADER_EXPORT___;
